import React from 'react'

const Icon = ({ type, inlineWithText }) => {
  return <span className={`icon icon--${type}${inlineWithText ? ' icon--inlineWithText' : ''}`} />
}

export default Icon
